import { render, staticRenderFns } from "./MemberPage.vue?vue&type=template&id=2e1edf00&scoped=true"
import script from "./MemberPage.vue?vue&type=script&lang=js"
export * from "./MemberPage.vue?vue&type=script&lang=js"
import style0 from "./MemberPage.vue?vue&type=style&index=0&id=2e1edf00&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1edf00",
  null
  
)

export default component.exports